module.exports = __webpack_public_path__ + "static/img/作品43.9e38613.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品43.png
// module id = Z+OP
// module chunks = 1